import { render, staticRenderFns } from "./vitiligoBasicInfoDialog.vue?vue&type=template&id=0a5b92bc&scoped=true&"
import script from "./vitiligoBasicInfoDialog.vue?vue&type=script&lang=js&"
export * from "./vitiligoBasicInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./vitiligoBasicInfoDialog.vue?vue&type=style&index=0&lang=less&"
import style1 from "./vitiligoBasicInfoDialog.vue?vue&type=style&index=1&id=0a5b92bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b92bc",
  null
  
)

export default component.exports